import axios from "axios";

export const instance = axios.create({
  timeout: 10000
});

export const getGroupCard = id => {
  const response = instance({
    method: "get",
    url: `/work/api/group/${id}/card`
  });
  return response;
};


export const getGroupsList = () => {
  const response = instance({
    method: "get",
    url: "/work/api/dict/4"
  });
  return response;
};

export const getPlanList = () => {
  const response = instance({
    method: "get",
    //url: "/work/api/program-plan-actual"
    url: "/work/api/study/plan-actual"
  });
  return response;
};

export const getGroupInfo = id => {
  const response = instance({
    method: "get",
    url: `/work/api/group/${id}`
  });
  return response;
};

export const getGroupMainInfo = id => {
  const response = instance({
    method: "get",
    url: `/work/api/group/${id}/main`
  });
  return response;
};

export const getGroupStudents = id => {
  const response = instance({
    method: "get",
    url: `/work/api/group/${id}/students`
  });
  return response;
};

/*export const getGroupPlan = id => {
  const response = instance({
    method: "get",
    url: `/work/api/group/${id}/plan`
  });
  return response;
};*/

export const getGroupProgram = id => {
  const response = instance({
    method: "get",
    url: `/work/api/group/${id}/program`
  });
  return response;
};

export const createGroup = data => {
  const response = instance({
    method: "post",
    url: `/work/api/group/`,
    data
  });
  return response;
};

export const createNewStudent = (main, groupId) => {
  const data = {
    type : "create-student",
    group : groupId,
    lastName : main.lastName,
    firstName : main.firstName,
    middleName : main.middleName,
    sex : main.sex,
    birthday : main.birthday,
    snils : main.snils,
    region : main.region,
    municipal : main.municipal,
    phone : main.phone,
    email : main.email,
    register : main.register
  };

  const response = instance({
    method: "post",
    url: `/work/api/group/rpc`,
    headers: {
      "Content-Type": "application/json",
    },
    data
  });
  return response;
}

export const moveStudent = (studentId, fromId, toId) => {
  const data = {
    type : "move-student",
    from : fromId,
    to : toId,
    student : studentId
  };

  const response = instance({
    method: "post",
    url: `/work/api/group/rpc`,
    headers: {
      "Content-Type": "application/json",
    },
    data
  });
  return response;
}

export const addStudent = (studentId, groupId) => {
  const data = {
    type : "add-student",
    group : groupId,
    student : studentId
  };

  const response = instance({
    method: "post",
    url: `/work/api/group/rpc`,
    headers: {
      "Content-Type": "application/json",
    },
    data
  });
  return response;
}

export const updateGroup = (id, main) => {
  const data = { main: { ...main, } };

  const response = instance({
    method: "put",
    url: `/work/api/group/${id}`,
    data
  });
  return response;
};

export const deleteGroup = id => {
  const response = instance({
    method: "delete",
    url: `/work/api/group/${id}`
  });
  return response;
};

export const deleteStudentFromGroup = (studentId, groupId) => {
  const data = {
    type : "remove-student",
    group : groupId,
    student : studentId
  };

  const response = instance({
    method: "post",
    url: `/work/api/group/rpc`,
    headers: {
      "Content-Type": "application/json",
    },
    data
  });
  return response;
}

export const uploadImportFile = (file) => {
  const data = new FormData();
  data.set('file', file, file.name);

  const response = instance({
    method: "post",
    url: `/work/api/file`,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data
  });
  return response;
}

export const checkImport = (groupId, fileId) => {
  const data = {
    type : "check-import",
    group : groupId,
    file : fileId,
    encoding : "UTF-8"
  };

  const response = instance({
    method: "post",
    url: `/work/api/group/rpc`,
    data
  });
  return response;
}

export const execImportFile = (groupId, fileId, resolve) => {
  const data = {
    type : "exec-import",
    group : groupId,
    file : fileId,
    encoding : "UTF-8",
    resolve : resolve
  };

  const response = instance({
    method: "post",
    url: `/work/api/group/rpc`,
    data
  });
  return response;
}

export const getRequestGroup = (groupId) => {
	const response = instance({
	  method: "get",
	  url: `/work/api/group-request/${groupId}`,
	});
	return response;
};

export const changeStatusGroup = (groupId, type) => {
  const data = {
    type : type,
    id : groupId
  };

  const response = instance({
    method: "post",
    url: `/work/api/group/rpc`,
    data
  });
  return response;
}

export const getTeachers = (id) => {
  const response = instance({
    method: "get",
    url: `/work/api/group/${id}/teachers`
  });
  return response;
};

export default {
  getGroupCard,
  getGroupsList,
  getGroupInfo,
  getGroupMainInfo,
  getGroupStudents,
  //getGroupPlan,
  getGroupProgram,
  getPlanList,
  createGroup,
  deleteGroup,
  updateGroup,
  createNewStudent,
  deleteStudentFromGroup,
  moveStudent,
  addStudent,
  uploadImportFile,
  checkImport,
  execImportFile,
  changeStatusGroup,
  getRequestGroup,
  getTeachers
};
